import { render } from "./TimerVsDisplay.vue?vue&type=template&id=5ff61afd&scoped=true"
import script from "./TimerVsDisplay.vue?vue&type=script&lang=js"
export * from "./TimerVsDisplay.vue?vue&type=script&lang=js"

import "./TimerVsDisplay.vue?vue&type=style&index=0&id=5ff61afd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff61afd"]])

export default __exports__